"use client";

import React from "react";
import { CustomerType } from "../services/customer-service";
import DropdownSelectOne from "../../../components/custom/dropdown-select-one";

interface CustomerTypeSelectProps {
  value?: CustomerType;
  onChange?: (value: CustomerType) => void;
  disabled?: boolean;
  showLabel?: boolean; // 
}

const CUSTOMER_TYPE_OPTIONS = [
  { label: "Doanh nghiệp", value: CustomerType.ENTERPRISE },
  { label: "Hộ gia đình", value: CustomerType.HOUSEHOLD },
];

export const CustomerTypeSelect: React.FC<CustomerTypeSelectProps> = ({
  value = 0,
  onChange,
  disabled = false,
  showLabel = true,
}) => {
  return (
    <div className="flex flex-col space-y-1 w-[220px]">
      {showLabel && (
        <label className="text-sm font-medium text-slate-600">
          Loại khách hàng
        </label>
      )}

      <DropdownSelectOne
        options={CUSTOMER_TYPE_OPTIONS}
        selectedId={value}
        onChange={(option) => {
          onChange?.(option.value as CustomerType)
        }}
        getOptionLabel={(option) => option.label}
        getOptionKey={(option) => option.value}
        defaultOption={{ label: "Tất cả loại KH", value: 0 }}
        isSearchLocal={true}
        handleFilterChange={() => { }}
        timeDelay={300}
      />
    </div>
  );
};

export default CustomerTypeSelect;
